import { render } from "./ProductAnalyticsPage.vue?vue&type=template&id=30c0495c"
import script from "./ProductAnalyticsPage.vue?vue&type=script&lang=js"
export * from "./ProductAnalyticsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__